import type { Action } from 'state/actions';

import type { DailyBlotterQuotesReceived } from '../dailyBlotter.action';
import type { Infos } from '../dailyBlotter.model';
import { initialDailyBlotterInfosState } from '../dailyBlotter.model';

export function infosReducer(state: Infos = initialDailyBlotterInfosState, action: Action): Infos {
  switch (action.type) {
    case 'DAILY_BLOTTER_QUOTES_REQUESTED':
      return { ...state, isFetchingQuotes: true };

    case 'DAILY_BLOTTER_QUOTES_REQUEST_FAILED':
      return { ...state, isFetchingQuotes: false };

    case 'DAILY_BLOTTER_QUOTES_RECEIVED':
      return onMiniBlotterQuotesReceived(state, action);

    case 'DAILY_BLOTTER_PAGE_CHANGED':
      return { ...state, page: action.pageIndex };

    case 'DAILY_BLOTTER_ITEMS_PER_PAGE_CHANGED':
      return { ...state, size: action.itemsPerPage, page: action.page };

    case 'DAILY_BLOTTER_FILTERS_UPDATED':
      return { ...state, filters: action.filters };

    default:
      return state;
  }
}

function onMiniBlotterQuotesReceived(state: Infos, { quotes, pageInfo }: DailyBlotterQuotesReceived): Infos {
  const quotesId = state.quotesId;
  const newQuoteIds = quotes.map(quote => quote.externalQuoteId);
  const { page, size: itemsPerPage, totalElements, totalPages } = pageInfo;

  return isSameQuotesId(quotesId, newQuoteIds)
    ? {
        ...state,
        isFetchingQuotes: false,
        page: page + 1,
        size: itemsPerPage,
        totalElements,
        totalPages,
      }
    : {
        ...state,
        quotesId: newQuoteIds,
        isFetchingQuotes: false,
        page: page + 1,
        size: itemsPerPage,
        totalElements,
        totalPages,
      };
}

function isSameQuotesId(quotesId: string[] = [], newQuoteIds: string[] = []) {
  return quotesId.join(',') === newQuoteIds.join(',');
}
